import "./_Chip.scss";

const Chip = ({ label }) => {
  return <p className="chip">{label}</p>;
};

export default Chip;
